import { LanguageService } from '@canvas-logic/engine';

export const languageService = new LanguageService();
